<template>
  <div class="flex flex-col items-center min-h-screen lg:bg-zircon overflow-y-auto">
    <div
      class="flex flex-col justify-center w-full lg:max-w-2xl"
      :style="{
        minHeight: 'calc(100% - 6rem)',
        margin: '3rem auto',
      }">
      <div class="
        flex flex-col items-center bg-white lg:rounded-lg
        w-full py-12 px-8 md:px-32 space-y-6
      ">
        <b class="text-2xl leading-normal text-center">Завершение регистрации</b>
        <span class="leading-relaxed text-center">
          Вам отправлено СМС-сообщение с кодом подтверждения регистрации.
        </span>
        <Code @input="($event) => code = $event" :invalid="invalid"/>
        <p class="text-sm text-center">
          Если вам не пришло сообщение в течение 2 минут,
          <span
            class="text-info cursor-pointer underline"
            :class="{
              'opacity-50 pointer-events-none': pending || requestPending,
            }"
            @click="getNewOne()">
            нажмите здесь</span>
          для повторного запроса.
        </p>
        <button
          class="btn bg-primary border-solid border-primary text-white w-full"
          :disabled="pending"
          :class="{
            'opacity-50 pointer-events-none': pending,
          }"
          @click="onCheck()">
          Подтвердить код
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Code from '@/components/global/Code.vue';
import { mapActions } from 'vuex';

export default {
  components: {
    Code,
  },

  data() {
    return {
      code: null,
      invalid: 0,
      pending: false,
      requestPending: false,
      success: false,
    };
  },

  methods: {
    ...mapActions({
      CHECK_CODE: 'ACT_CHECK_CODE',
      REQUEST_CONFIRMATION_CODE: 'ACT_REQUEST_CONFIRMATION_CODE',
    }),

    getNewOne() {
      if (this.pending || this.requestPending) {
        return;
      }

      this.requestPending = true;

      this.REQUEST_CONFIRMATION_CODE()
        .then(() => {
          this.$iwalyNotify.success({
            text: 'Новый код отправлен.',
          });
        })
        .catch((error) => {
          this.$iwalyNotify.error({
            text: this.getErrorMessage(error),
          });
        })
        .finally(() => {
          this.requestPending = false;
        });
    },

    onCheck() {
      if (this.code === null) {
        return;
      }

      if (this.pending || this.success) {
        return;
      }

      this.pending = true;

      this.CHECK_CODE(this.code)
        .then(() => {
          this.success = true;
        })
        .catch((error) => {
          this.$iwalyNotify.error({
            text: this.getErrorMessage(error, 'Код подтверждения введён неверно'),
          });
          this.invalid = 1;
        })
        .finally(() => {
          this.pending = false;
        });
    },

    getErrorMessage(error, fallbackText = 'Не удалось выполнить действие') {
      const status = error && error.response
        ? error.response.status
        : null;

      const responseData = error && error.response
        ? error.response.data || {}
        : {};

      const responseError = responseData.error || null;
      const responseMessage = responseData.message || null;

      if (responseError === 'phone_already_registered') {
        return 'Этот номер уже зарегистрирован в системе. Если вы уже пользовались iWALY, войдите в аккаунт.';
      }

      if (responseError === 'too_many_phone_code_requests' || status === 429) {
        return responseMessage || 'Слишком много запросов кода. Повторите попытку позже.';
      }

      if (responseError === 'invalid_phone') {
        return 'Номер телефона указан неверно.';
      }

      if (responseError === 'unknown_phone') {
        return 'Номер телефона не найден. Запросите код подтверждения повторно.';
      }

      if (responseError === 'invalid_code') {
        return 'Код подтверждения введён неверно.';
      }

      if (responseError === 'not_allowed_region') {
        return 'Регистрация исполнителей в выбранном регионе пока недоступна.';
      }

      if (responseError === 'not_allowed_service_category') {
        return 'Одна из выбранных категорий услуг сейчас недоступна.';
      }

      if (status === 422) {
        return 'Проверьте заполненные данные и попробуйте ещё раз.';
      }

      return fallbackText;
    },
  },

  watch: {
    code() {
      this.invalid = 0;
    },
  },
};
</script>
